import React from 'react'
import BrowseLibrary from '../../components/BrowseLibrary/BrowseLibrary'

const BrowseLibraryPage = () => {
  return (
    <div><BrowseLibrary/></div>
  )
}

export default BrowseLibraryPage